module.exports = __webpack_public_path__ + "img/allyLocationPhoto.86eb6896.png";